import React from 'react';
import { useAuth } from '../context/auth-context';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button';

const LoginPage: React.FC = () => {
  const { login, isLoading } = useAuth();
  const { t } = useTranslation();

  const handleLogin = () => {
    login();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-xl shadow-lg border border-[#008cff]/20">
        {/* Logo */}
        <div className="flex justify-center">
          <img
            src="/mohre-logo.png"
            alt="MOBILY Logo"
            className="h-40 w-auto drop-shadow-md"
          />
        </div>

        {/* Title */}
        <div className="text-center">
          <h1 className="text-3xl font-bold text-[#005aa4]">
            {t('app.title', 'Customer 360 Application')}
          </h1>

          <div className="mt-2 h-1 w-32 bg-gradient-to-r from-[#005aa4] to-[#008cff] mx-auto rounded-full"></div>
        </div>

        {/* Description */}
        <p className="text-center text-[#005aa4]/80">
          {t(
            'login.description',
            'Sign in with your MOBILY credentials to access the Customer 360 application'
          )}
        </p>

        {/* Login Button */}
        <div className="mt-8">
          <Button
            onClick={handleLogin}
            disabled={isLoading}
            className="w-full py-6 text-lg bg-[#008cff] hover:bg-[#005aa4] text-white font-medium rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1"
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                {t('login.signingIn', 'Signing in...')}
              </span>
            ) : (
              t('login.signIn', 'Sign In')
            )}
          </Button>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-[#008cff]/10 rounded-br-full"></div>
      <div className="absolute bottom-0 right-0 w-32 h-32 bg-[#005aa4]/10 rounded-tl-full"></div>
    </div>
  );
};

export default LoginPage;
